import { useState, useEffect } from 'react';

/**
 * A custom hook that returns `true` if the screen width is below a certain threshold.
 * @param {number} maxWidth - The maximum width to consider as mobile (defaults to 450px).
 * @returns {boolean} - True if the screen is mobile-sized, false otherwise.
 */
const UseIsMobile = (maxWidth = 450) => {
  // Initialize state with the current window width
  const [isMobile, setIsMobile] = useState(window.innerWidth <= maxWidth);

  useEffect(() => {
    // Handler to call on window resize
    const handleResize = () => {
      setIsMobile(window.innerWidth <= maxWidth);
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, [maxWidth]); // Only re-run the effect if maxWidth changes

  return isMobile;
};

export default UseIsMobile;
